export const environment = {
  production: false,
  newServiceUrl: 'https://wsloginappqa.claropr.com/api/',
  localApi: false,
  deployAssetsPath: '',
  version: '001'
};

